import { Component, OnInit, ViewChild } from "@angular/core";
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { ActivatedRoute } from "@angular/router";
import { MemoriesService } from "../service/memories.service";
import { SidebarService } from 'src/app/core/services/sidebar.service';
MemoriesService;
@Component({
  selector: "app-memories-gallery",
  templateUrl: "./memories-gallery.component.html",
  styleUrls: ["./memories-gallery.component.css"],
})
export class MemoriesGalleryComponent implements OnInit {
  sidebarCollapsed: boolean = false;
  @ViewChild("slickMain") slickMain: SlickCarouselComponent | undefined;
  @ViewChild("slickThumbs") slickThumbs: SlickCarouselComponent | undefined;
  name: string;
  memories_id: number;
  slides: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private memories: MemoriesService,
    private sidebarService: SidebarService
  ) {}

  ngOnInit(): void {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });
    
    this.memories_id = this.route.snapshot.params["id"];
    this.GetSlidesByMemoriesId(this.memories_id);
  }
  slideConfigMain = {
    slidesToShow:1,
    slidesToScroll:1,
    asNavFor: ".slick-thumbs",
    // autoplay: true,
    // autoplaySpeed: 5000,
    pauseOnHover: true,
    infinite: true,
    arrows:true,
    
  };

  slideConfigThumbs = {
    slidesToShow:6,
    slidesToScroll:1,
    asNavFor: ".slick-main",
    centerMode:true,
    infinite:true,
    focusOnSelect:true,
    arrows: false,
  };

  GetSlidesByMemoriesId(MemoriesId:number): void {
    this.memories.getSingleMemories(MemoriesId).subscribe((response: any) => {
      this.slides =response.files.map((file, index) => ({
        ...file,
        index,
      }));

      console.log(this.slides);
      if (this.slickMain && this.slickThumbs) {
        this.slickMain.slickGoTo(0);
        this.slickThumbs.slickGoTo(0);
      }
    });
  }

  goToSlide(index: number): void {
    if (this.slickMain) {
      this.slickMain.slickGoTo(index);
    }
  }

}
